import { Box, ButtonBase, styled } from "@mui/material";

import {
    COLORS,
    RADIUS,
    SHADOW,
    TYPOGRAPHY,
} from "../../CreationModal.constants";
import { buttonBaseReset, transientOptions } from "../../CreationModal.styled";

export type StepState = "active" | "done" | "upcoming";

export const Wrap = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: 4,
    borderRadius: RADIUS.md,
    backgroundColor: COLORS.slate50,
    border: `1px solid rgba(226, 232, 240, 0.7)`,
    "& .step-chevron": {
        fontSize: 14,
        color: COLORS.slate400,
        margin: "0 4px",
    },
    // Too wide for the full-screen mobile header next to the title.
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));

export const Step = styled(
    ButtonBase,
    transientOptions,
)<{ $state: StepState }>(({ $state }) => ({
    ...buttonBaseReset,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "4px 10px",
    borderRadius: 6,
    whiteSpace: "nowrap",
    ...TYPOGRAPHY.labelXs,
    fontSize: 12,
    cursor: $state === "done" ? "pointer" : "default",
    ...($state === "active" && {
        fontWeight: 600,
        color: COLORS.primaryDark,
        backgroundColor: COLORS.primarySoft,
        border: `1px solid ${COLORS.primarySoftBorder}`,
        boxShadow: SHADOW.xs,
    }),
    ...($state === "done" && {
        color: COLORS.slate500,
        "&:hover": { color: COLORS.primaryDark },
        "& svg": { fontSize: 14, color: COLORS.primary },
    }),
    ...($state === "upcoming" && {
        color: COLORS.slate400,
    }),
    "& .step-dot": {
        width: 6,
        height: 6,
        borderRadius: RADIUS.full,
        backgroundColor: COLORS.primary,
    },
}));
